import React, { useState, useEffect, useRef } from 'react';
import TR from './../../Trans';
import { Capacitor } from '@capacitor/core';
import Button from '@mui/material/Button';
import FormGroup from '@mui/material/FormGroup';
import PlayArrowIcon from '@mui/icons-material/PlayArrow';
import BDialog from './BDialog';
import DialogActions from '@mui/material/DialogActions';
import AddPlayList from './../dialogs/AddPlayList';
import TextField from '@mui/material/TextField';
import AddCircleIcon from '@mui/icons-material/AddCircle';
import Grid from '@mui/material/Grid';
import AddSinger from './../dialogs/AddSinger';
import { Keyboard } from '@capacitor/keyboard';
import IconButton from '@mui/material/IconButton';
import DialogContent from '@mui/material/DialogContent';
import MuvikaService from './../../services/muvika';
import MenuItem from '@mui/material/MenuItem';
import DialogPlayer from '../player/DialogPlayer';
import Select from '@mui/material/Select';
import PositionButtons from '../items/PositionButtons';
import SelectSongPosition from './SelectSongPosition';
import Paper from '@mui/material/Paper';
import InfoIcon from '@mui/icons-material/Info';
import Stack from '@mui/material/Stack';
import FormControl from '@mui/material/FormControl';
import InputLabel from '@mui/material/InputLabel';
import CreatorsDialog from './CreatorsDialog';
import PitchButtons from '../items/PitchButtons';
import sessionStore from './../../stores/session';
import accountStore from '../../stores/account';
import settingsStore from '../../stores/settings';
import singersStore from './../../stores/singers';
import performanceStore from '../../stores/performance';
import messageStore from './../../stores/message';
import EditPlayList from './EditPlayList';
import { Views } from './../../enums/enums';
import Link from '@mui/material/Link';
import searchStore from '../../stores/search';
import navigationStore from '../../stores/navigation';
import songbookQueueStore from '../../stores/songbookQueue';

function EditPlayListPerformance(props) {

  const singerRef = useRef(null);

  const sessionToken = sessionStore((state) => state.sessionToken);
  const addSingerLocally = singersStore((state) => state.addSingerLocally);
  const settings = settingsStore((state) => state.settings);
  const getSettings = settingsStore((state) => state.getSettings);
  const account = accountStore((state) => state.account);
  const getAccount = accountStore((state) => state.getAccount);
  const setError = messageStore((state) => state.setError);
  const isQueueingOn = songbookQueueStore((state) => state.isQueueingOn);

  const itemsOnPage = 25;
  const setSearchQuery = searchStore((state) => state.setSearchQuery);
  const goToView = navigationStore((state) => state.goToView);
  const search = searchStore((state) => state.search);
  const setOnlyArtist = searchStore((state) => state.setOnlyArtist);

  const editSinger = singersStore((state) => state.editSinger);

  const [currentSinger, setCurrentSinger] = useState(null);
  const [lastChosenSinger, setLastChosenSinger] = useState(null);
  const [currentSingerName, setCurrentSingerName] = useState(null);
  const [currentPlayList, setCurrentPlayList] = useState(null);
  const [initPlayList, setInitPlayList] = useState(null);
  const [isSongbookQueue, setIsSongbookQueue] = useState(false);

  const dialogRef = useRef(null);

  const [isAddPlayListOpen, setIsAddPlayListOpen] = useState(false);

  const getInitPitch = () => {
    if (props.track && account.tags.includes("consumer")) {
      return props.track.last_pitch ? props.track.last_pitch : 0;
    }
    return 0;
  };

  const [currentPitch, setCurrentPitch] = useState(getInitPitch());
  const [creators, setCreators] = useState(null);
  const [currentPos, setCurrentPos] = useState(null);
  const [isDefaultSingerSet, setIsDefaultSingerSet] = useState(false);

  const handleOpenAddPlayList = () => {
    setIsAddPlayListOpen(true);
  };

  const handleCloseAddPlayList = () => {
    setIsAddPlayListOpen(false);
  };

  const [isSelectSongPositionOpen, setIsSelectSongPositionOpen] = useState(false);

  const handleOpenSelectSongPosition = () => {
    setIsSelectSongPositionOpen(true);
  };

  const handleCloseSelectSongPosition = () => {
    setIsSelectSongPositionOpen(false);
  };

  const handlePlayListCreation = (playListName) => {
    if (playListName.length > 0) {
      setIsAddPlayListOpen(false);
      MuvikaService.createPlayList(sessionToken, playListName)
        .then(function (res) {
          if (res.data.error) {
            messageStore.getState().setError(sessionToken, res.data.error.code, res.data.error.details.length > 0 ? res.data.error.details : res.data.error.string);
          } else {
            performanceStore.getState().getPlayLists(sessionToken, false);
            let newPlayList = res.data.data;
            if (!newPlayList.items) {
              newPlayList.items = [];
            }
            setCurrentPlayList(newPlayList);
            setIsAddPlayListOpen(false);
          }
        });
    } else {
      setError(sessionToken, 0, TR.cm_name_cannot_be_empty);
    }
  };

  const getSingerInOrder = () => {
    if (props.track) {
      let value = props.track.last_singer_id;
      if (value) {
        let singer = props.singers.find(x => x.id == value);
        if (singer) {
          return singer;
        }
      } else {
        if (lastChosenSinger) {
          let singer = props.singers.find(x => x.id == lastChosenSinger.id);
          if (singer) {
            return singer;
          }
        }
      }
      let lastSingerId = props.singers.length > 0 ? props.singers[0].id : null;
      if (lastSingerId) {
        let singer = props.singers.find(x => x.id == lastSingerId);
        if (singer) {
          return singer;
        }
      }
    }
  };

  const setDefaultSinger = () => {
    if (props.singers) {
      let singer = getSingerInOrder();
      setCurrentSinger(singer);
      if (account.tags.includes("consumer")) {
        setCurrentSingerName(singer ? singer.name : "");
      } else {
        setCurrentSingerName("");
      }
    }
  };

  const selectAll = () => {
    if (singerRef.current) {
      singerRef.current.select();
    }
  };

  useEffect(() => {
    if (isDefaultSingerSet) {
      selectAll();
      setIsDefaultSingerSet(false);
    }
  }, [isDefaultSingerSet]);

  const scrollToDown = () => {
    const dialogContainers = document.getElementsByClassName("MuiDialog-container");
    const textFields = document.getElementsByClassName("muvika-dialog-name");

    if (dialogContainers.length > 0 && textFields.length > 0) {
      for (let i = 0; i < dialogContainers.length; i++) {
        const container = dialogContainers[i];
        const textField = textFields[0];
        const offsetTop = textField.offsetTop - container.offsetTop;
        container.scrollTop = offsetTop;
      }
    }
  };


  useEffect(() => {
    if (props.open && account) {
      if (Capacitor.isNativePlatform()) {
        Keyboard.addListener('keyboardDidShow', info => {
          setTimeout(() => scrollToDown(), 100);
          Keyboard.removeAllListeners();
        });
      } else {
        setTimeout(() => scrollToDown(), 100);
      }
      setCurrentSinger(props.singer);
      setCurrentSingerName(props.singer.name);
      setCurrentPitch(props.pitch);
      console.log("isPlayingNow", props.isPlayingNow);
      if (props.isPlayingNow) {
        setCurrentPos(props.playQueue.items.length);
        setCurrentPlayList(null);
      } else {
        if (settings) {
          if (!settings.usage_mode || settings.usage_mode === "restaurant") {
            setCurrentPlayList(props.playList);
          } else if (settings.usage_mode === "booth") {
            setCurrentPlayList(null);
          }
        }
        if (props.performance) {
          if (settings) {
            if (!settings.usage_mode || settings.usage_mode === "restaurant") {
              setCurrentPos(props.performance.position);
            } else if (settings.usage_mode === "booth") {
              if (settingsStore.getState().settings?.smartq_enabled) {
                setCurrentPos(-2);
              } else {
                setCurrentPos(props.playQueue.items.length);
              }
            }
          }
        } else {
          if (settings) {
            if (!settings.usage_mode || settings.usage_mode === "restaurant") {
              setCurrentPos(props.playList.items.length);
            } else if (settings.usage_mode === "booth") {
              if (settingsStore.getState().settings?.smartq_enabled) {
                setCurrentPos(-2);
              } else {
                setCurrentPos(props.playQueue.items.length);
              }
            }
          }
        }
      }
    }
  }, [props.open]);

  useEffect(() => {
    if (props.performance) {
      if (settings) {
        if (!settings.usage_mode || settings.usage_mode === "restaurant") {
          setCurrentPos(props.performance.position);
        } else if (settings.usage_mode === "booth") {
          if (settingsStore.getState().settings?.smartq_enabled) {
            setCurrentPos(-2);
          } else {
            setCurrentPos(props.playQueue.items.length);
          }
        }
      }
    }
  }, [props.performance]);

  useEffect(() => {
    if (!account) {
      getAccount(sessionToken);
    }
    if (!settings) {
      getSettings(sessionToken);
    }
    getCreators();
  }, []);

  useEffect(() => {
    console.log("playList", currentPlayList);
    if (currentPlayList) {
      if (currentPlayList.id === props.playList.id) {
        if (props.performance) {
          console.log("pos", props.performance.position);
          setCurrentPos(props.performance.position);
        } else {
          setCurrentPos(props.playList.items.length - 1);
        }
      } else {
        setCurrentPos(currentPlayList.items.length);
      }
    } else if (props.playQueue) {
      if (settingsStore.getState().settings?.smartq_enabled) {
        setCurrentPos(-2);
      } else {
        setCurrentPos(props.playQueue.items.length);
      }
    }
  }, [currentPlayList]);

  const getCreators = () => {
    if (props.track) {
      if (props.track.track_id) {
        MuvikaService.getTrackCreators(sessionToken, props.track.track_id)
          .then(function (res) {
            if (res.data.data) {
              if (res.data.error) {
                setError(sessionToken, res.data.error.code, res.data.error.details.length > 0 ? res.data.error.details : res.data.error.string);
              } else {
                setCreators(res.data.data.items);
              }
            }
          })
          .catch(function () { });
      }
    }
  };

  const handlePosChange = (event) => {
    let pos = event.target.value;
    console.log(pos);
    if (pos || pos == 0) {
      pos = parseInt(pos);
      if (pos != -1) {
        setCurrentPos(pos);
      }
    } else {
      pos = -1;
    }
    if (pos === -1) {
      handleOpenSelectSongPosition();
    }
  };

  const handleChoosePosition = (pos) => {
    if (pos || pos == 0) {
      if (currentPlayList) {
        if (pos >= currentPlayList.items.length) {
          setCurrentPos(currentPlayList.items.length);
        } else {
          setCurrentPos(pos);
        }
      } else {
        if (props.playQueue) {
          if (pos >= props.playQueue.items.length) {
            setCurrentPos(props.playQueue.items.length - 1);
          } else {
            setCurrentPos(pos);
          }
        }
      }
    }
    handleCloseSelectSongPosition();
  };

  const [isCreatorsDialogOpen, setIsCreatorsDialogOpen] = useState(false);

  const handleOpenCreatorsDialog = () => {
    getCreators();
    setIsCreatorsDialogOpen(true);
  };

  const handleCloseCreatorsDialog = () => {
    setIsCreatorsDialogOpen(false);
  };

  const [isAddSingerOpen, setIsAddSingerOpen] = useState(false);

  const handleOpenAddSinger = () => {
    setIsAddSingerOpen(true);
  };

  const handleCloseAddSinger = () => {
    setIsAddSingerOpen(false);
  };

  const handlePitchChange = (event, newPitch) => {
    setCurrentPitch(newPitch);
  };

  const singerList = () => {
    if (props.singers) {
      return props.singers.map((singer) =>
        <MenuItem key={singer.id} value={singer.id}>{singer.name}</MenuItem>
      );
    }
  };

  const playListList = () => {
    if (settings) {
      if (!settings.usage_mode || settings.usage_mode === "restaurant") {
        if (props.playLists) {
          return props.playLists.map((playList) =>
            <MenuItem key={playList.id} value={playList.id}>{playList.name}</MenuItem>
          );
        }
      }
    }
  };

  const handleSingerChange = (event) => {
    let singerId = event.target.value;
    let singer = props.singers.find(x => x.id == singerId);
    if (singer) {
      setCurrentSinger(singer);
      setLastChosenSinger(singer);
    }
  };

  const handleSingerSet = (event) => {
    let singerName = event.target.value;
    setCurrentSingerName(singerName);
  };

  const handlePlayListChange = (event) => {
    let playListId = event.target.value;
    if (playListId == -1) {
      setCurrentPlayList(null);
      setIsSongbookQueue(false);
    } else if (playListId == -2) {
      setCurrentPlayList(null);
      setIsSongbookQueue(true);
    } else {
      let playList = props.playLists.find(x => x.id == playListId);
      if (playList) {
        if (!playList.items) {
          playList.items = [];
        }
        setCurrentPlayList(playList);
        setIsSongbookQueue(false);
      }
    }
  };

  const renderMenuItemSongbookQueue = () => {
    if (isQueueingOn) {
      return <MenuItem value={-2}>{TR.cm_songbook_queue}</MenuItem>;
    }
  };

  const playListContainer = () => {
    if (props.playLists) {
      let val = -1;
      if (isSongbookQueue) val = -2;
      if (currentPlayList) val = currentPlayList.id;
      return <FormGroup>
        <InputLabel id="new-playlist-label">{TR.cm_playlist}</InputLabel>
        <Grid container spacing={0}>
          <Grid item xs={10.5}>
            <Select
              className="muvika-dialog-select"
              labelId="new-playlist-label"
              label="Playlist"
              value={val}
              onChange={handlePlayListChange}
            >
              <MenuItem value={-1}>{TR.cm_current_playqueue}</MenuItem>
              {renderMenuItemSongbookQueue()}
              {playListList()}
            </Select>
          </Grid>
          <Grid item xs={1.5}>
            {renderAddPlayListButton()}
          </Grid>
        </Grid>
      </FormGroup>;
    }
  };

  const handleSingerCreation = (singerName, gender, email) => {
    if (singerName) {
      singerName = singerName.trim();
      if (singerName.length > 0) {
        MuvikaService.createSinger(sessionToken, singerName, gender, email)
          .then(function (res) {
            if (res.data.data) {
              addSingerLocally(res.data.data);
              if (res.data.data.id) {
                setCurrentSinger(res.data.data);
              } else {
                setError(sessionToken, 0, TR.cm_failed_to_create_singer);
              }
            }
          })
          .catch(function () { });
        setIsAddSingerOpen(false);
      } else {
        setError(sessionToken, 0, TR.cm_name_cannot_be_empty);
      }
    }
  };

  const playNextButton = () => {
    if (accountStore.getState().account && settings && !isSongbookQueue) {
      if (accountStore.getState().account.subscription.valid != 0 && !settings.hide_play_now) {
        return <Button color="success" onClick={() => {
          handleEditPerformance(true);
        }}><span className="muvika-playnow-icon"><PlayArrowIcon /></span> {TR.cm_play_now}</Button>;
      }
    }
  };

  const handleEditPerformance = (playNow = false) => {
    if (account) {
      if (settings.singer_selection === "type") {
        let singerName = currentSingerName;
        if (singerName) {
          singerName = singerName.trim();
          if (singerName.length > 0) {
            MuvikaService.createSinger(sessionToken, singerName, "", "")
              .then(function (res) {
                //console.log(res);
                if (res.data.data) {
                  addSingerLocally(res.data.data);
                  if (res.data.data.id) {
                    let createdSinger = res.data.data;
                    setCurrentSinger(createdSinger);
                    if (res.data.error?.code === 2013 && singerName.toLowerCase() === res.data.data.name?.toLowerCase() && singerName !== res.data.data.name) {
                      editSinger(sessionToken, createdSinger.id, singerName, createdSinger.gender, createdSinger.email);
                    }
                    props.onEditPerformance(props.performanceId, createdSinger, currentPitch, playNow ? null : currentPlayList, playNow ? 0 : currentPos, playNow ? true : currentPos !== -2 && settingsStore.getState().settings?.smartq_enabled, playNow, isSongbookQueue);
                  } else {
                    setError(sessionToken, 0, TR.cm_failed_to_create_singer);
                  }
                }
              })
              .catch(function () { });
          } else {
            setError(sessionToken, 0, TR.cm_name_cannot_be_empty);
          }
        } else {
          setError(sessionToken, 0, TR.cm_name_cannot_be_empty);
        }
      } else {
        props.onEditPerformance(props.performanceId, currentSinger, currentPitch, playNow ? null : currentPlayList, playNow ? 0 : currentPos, playNow ? true : currentPos !== -2 && settingsStore.getState().settings?.smartq_enabled, playNow, isSongbookQueue);
      }
    }
  };

  const singerForm = () => {
    if (settings) {
      if (settings.singer_selection === "type") {
        return <FormGroup>
          <InputLabel>{TR.cm_singer}</InputLabel>
          <TextField
            className="muvika-dialog-name"
            size="small"
            inputRef={singerRef}
            margin="dense"
            type="email"
            fullWidth
            value={currentSingerName}
            onChange={handleSingerSet}
          />
        </FormGroup>;
      }
    }
    if (currentSinger) {
      return <FormGroup>
        <InputLabel id="new-singer-label">{TR.cm_singer}</InputLabel>
        <Grid container spacing={0}>
          <Grid item xs={10.5}>
            <Select
              className="muvika-dialog-select"
              labelId="new-singer-label"
              label={TR.cm_singer}
              value={currentSinger.id}
              onChange={handleSingerChange}
            >
              {singerList()}
            </Select>
          </Grid>
          <Grid item xs={1.5}>
            {renderAddSingerButton()}
          </Grid>
        </Grid>
      </FormGroup>;
    } else {
      if (props.singers?.length > 0) {
        return <FormGroup>
          <InputLabel id="new-singer-label">{TR.cm_singer}</InputLabel>
          <Grid container spacing={0}>
            <Grid item xs={10.5}>
              <Select
                className="muvika-dialog-select"
                labelId="new-singer-label"
                label={TR.cm_singer}
                value={props.singers[0].id}
                onChange={handleSingerChange}
              >
                {singerList()}
              </Select>
            </Grid>
            <Grid item xs={1.5}>
              {renderAddSingerButton()}
            </Grid>
          </Grid>
        </FormGroup>;
      } else {
        return <FormGroup>
          <InputLabel id="new-singer-label">{TR.cm_singer}</InputLabel>
          <Grid container spacing={0}>
            <Grid item xs={10.5}>
              <p className="muvika-no-singers">{TR.cm_no_singers}</p>
            </Grid>
            <Grid item xs={1.5}>
              {renderAddSingerButton()}
            </Grid>
          </Grid>
        </FormGroup>;
      }
    }
  };

  const renderAddSingerButton = () => {
    if (settings) {
      if (settings.singer_selection === "list") {
        return <IconButton className="muvika-dialog-plus-button" color="white" component="label" onClick={handleOpenAddSinger}>
          <AddCircleIcon />
        </IconButton>;
      }
    }
  };

  const renderAddPlayListButton = () => {
    if (settings) {
      if (!settings.usage_mode || settings.usage_mode === "restaurant") {
        return <IconButton className="muvika-dialog-plus-button" color="white" component="label" onClick={handleOpenAddPlayList}>
          <AddCircleIcon />
        </IconButton>;
      }
    }
  };

  const handleKeyDown = (event) => {
    if (event.key === 'Enter') {
      if (isAddSingerOpen) {
        handleSingerCreation();
      } else if (isCreatorsDialogOpen) {
        handleCloseCreatorsDialog();
      } else if (isAddPlayListOpen) {
        handlePlayListCreation();
      } else {
        handleEditPerformance();
      }
    }
  };

  const renderEditPerformanceButton = () => {
    if (currentPlayList) {
      //console.log(currentPlayList);
      if (currentPlayList.id === props.playList.id) {
        return <Button
          color="success"
          className="muvika-dialog-action-right"
          onClick={() => {
            handleEditPerformance();
          }}
        >{TR.cm_save}
        </Button>;
      } else {
        return <Button
          color="success"
          className="muvika-dialog-action-right"
          onClick={() => {
            handleEditPerformance();
          }}
        >
          {TR.cm_add_to_list}
        </Button>;
      }
    } else {
      return <Button
        color="success"
        className="muvika-dialog-action-right"
        onClick={() => {
          handleEditPerformance();
        }}
      >
        {TR.cm_add_to_queue}
      </Button>;
    }
  };

  const renderPositionButtons = () => {
    if (settings && !isSongbookQueue) {
      console.log("pos", currentPos);
      let curPos = currentPos;
      if (currentPos || curPos == 0) {
        if (curPos > 2) {
          curPos = -1;
        }
      }
      if (currentPlayList) {
        if (currentPlayList.id === props.playList.id) {
          if (currentPos === currentPlayList.items.length - 1) {
            curPos = currentPlayList.items.length - 1;
          }
        } else if (currentPos === currentPlayList.items.length) {
          curPos = currentPlayList.items.length;
        }
        return <Paper className="muvika-pos-buttons">
          <p className="muvika-pos-title">
            {TR.cm_performance_pos}
          </p>
          <PositionButtons
            value={curPos}
            performances={currentPlayList.items}
            onPosChange={handlePosChange}
            currentPosition={currentPos}
            isPlayQueue={false}
            isSmartQ={settingsStore.getState().settings?.smartq_enabled}
            isAdding={currentPlayList.id !== props.playList.id}
          />
        </Paper>;
      } else if (props.playQueue) {
        if (currentPos === props.playQueue.items.length && !settingsStore.getState().settings?.smartq_enabled) {
          curPos = props.playQueue.items.length;
        }
        return <Paper className="muvika-pos-buttons">
          <p className="muvika-pos-title">
            {TR.cm_performance_pos}
          </p>
          <PositionButtons
            value={curPos}
            performances={props.playQueue.items}
            onPosChange={handlePosChange}
            currentPosition={currentPos}
            isPlayQueue={true}
            isAdding={true}
            isSmartQ={settingsStore.getState().settings?.smartq_enabled}
          />
        </Paper>;
      }
    }
  };

  const renderSelectSongPosition = () => {
    let curSingerName = currentSinger ? currentSinger.name : null;
    if (settings) {
      if (settings.singer_selection === "type") {
        curSingerName = currentSingerName;
      }
    }
    if (currentPlayList) {
      if (currentPlayList.id === props.playList.id) {
        return <SelectSongPosition
          open={isSelectSongPositionOpen}
          onClose={handleCloseSelectSongPosition}
          performances={currentPlayList.items}
          track={props.track}
          currentSingerName={curSingerName}
          performance={props.performance}
          onChoosePosition={(pos) => {
            handleChoosePosition(pos);
          }}
        />;
      } else {
        return <SelectSongPosition
          open={isSelectSongPositionOpen}
          onClose={handleCloseSelectSongPosition}
          performances={currentPlayList.items}
          track={props.track}
          currentSingerName={curSingerName}
          onChoosePosition={(pos) => {
            handleChoosePosition(pos);
          }}
        />;
      }
    } else if (props.playQueue) {
      return <SelectSongPosition
        open={isSelectSongPositionOpen}
        onClose={handleCloseSelectSongPosition}
        performances={props.playQueue.items}
        track={props.track}
        currentSingerName={curSingerName}
        onChoosePosition={(pos) => {
          handleChoosePosition(pos);
        }}
      />;
    }
  };

  const handleSearchArtist = () => {
    props.onClose();
    setOnlyArtist();
    setSearchQuery(props.track.artist);
    search(sessionToken, itemsOnPage);
    goToView(Views.Search);
  };

  return (
    <BDialog openToLeft={true} disableRestoreFocus ref={dialogRef} open={props.open} onKeyDown={handleKeyDown} onClose={() => {
      props.onClose();
    }}>
      {renderSelectSongPosition()}
      <AddSinger open={isAddSingerOpen} isPerformanceAdd={true} onClose={handleCloseAddSinger} onSingerCreation={handleSingerCreation} />
      <AddPlayList
        open={isAddPlayListOpen}
        onClose={handleCloseAddPlayList}
        onPlayListCreation={handlePlayListCreation}
      />
      <CreatorsDialog open={isCreatorsDialogOpen} onClose={handleCloseCreatorsDialog} creators={creators} track={props.track} />
      <DialogContent>
        <DialogPlayer track={props.track}/>
        <h4 className="muvika-track-title">
          <Link className="muvika-link-nodec" onClick={handleSearchArtist}>
            {props.track.artist}
          </Link> - {props.track.title} ({props.track.kcode})
          <IconButton color="white" component="label" onClick={handleOpenCreatorsDialog}>
            <InfoIcon />
          </IconButton>
        </h4>

        <Stack spacing={5}>
          {singerForm()}
          {playListContainer()}
          <Paper className="muvika-pitch-buttons">
            <p className="muvika-pitch-title">
              {TR.cm_key_pitch}
            </p>
            <PitchButtons value={currentPitch} onPitchChange={handlePitchChange} />
          </Paper>
          {renderPositionButtons()}
        </Stack>
      </DialogContent>
      <DialogActions>
        <Stack direction="row" spacing={4} justifyContent="center">
          <Button color="secondary" onClick={props.onClose}>{TR.cm_cancel}</Button>
          {renderEditPerformanceButton()}
          {playNextButton()}
        </Stack>
      </DialogActions>
    </BDialog>
  );
}

export default EditPlayListPerformance;